import React, { Component } from "react";

import Table from "rc-table";
import "rc-table/assets/index.css";

// import { ACTION_RULES, has_action } from '../../../helpers/authorization';
import Pagination from "./pagination/pagination";
import TableActions from "./actions/table-actions";
import Card from "../ui/card/card";

import "./table.scss";
import { IF } from "../ui/operators/if";
import Button from "../ui/button/button";
import ErrorModal from "../ui/modals/errorModal/errorModal";

const { Column } = Table;
// const NUMBER_ITEMS = [15, 30, 50, 100];

class ResponsiveTable extends Component {
	state = {
		visible: false,
		item: null,
		visibleDetail: false
	};

	constructor(props) {
		super(props);
		this.showDelete = this.showDelete.bind(this);
		this.hideDelete = this.hideDelete.bind(this);
		this.onDelete = this.onDelete.bind(this);

		this.showDetail = this.showDetail.bind(this);
		this.hideDetail = this.hideDetail.bind(this);
		this.onDetail = this.onDetail.bind(this);
	}

	showDelete = (item) => {
	    this.setState({
	        visible: true,
	        item: item
	    });
	};

	showDetail = (item) => {
	    this.setState({
	        visibleDetail: true,
	        item: item
	    });
	};

	hideDelete = () => {
	    this.setState({
	        visible: false,
	        item: null
	    });
	};
	
	onDelete() {
	    this.props.onDelete(this.state.item);
	    this.hideDelete();
	}

	onDetail() {
	    this.props.onDetail(this.state.item);
	    this.hideDetail();
	}

	hideDetail = () => {
	    this.setState({
	        visibleDetail: false,
	        item: null
	    });
	};

	// handleAdd() {
	//     const { router } = this.props;
	//     router.push(`${router.location.pathname}/novo`);
	// }


	// onSave(item) {
	//     this.props.onDetail(this.state.item);
	//     this.hideDetail();
	// }

	// handleChange = (value, index, event, item) => {
	//     this.props.number_items(value);
	// }

	renderColumns() {
		const { columns, actions_permissions } = this.props;
		const headers = columns.map((item, index) => (
			<Column className="table__column" {...item} key={index} />
		));
		// if (actions_permissions.length > 0) {
		if (true) {
			headers.push(
				<Column
					title="Ações"
					dataIndex="actions"
					className="table__column"
					key={headers.length}
					width={180}
					render={(text, record) => (
						<TableActions
							customID={this.props.customID || 'id'}
							key="action"
							item={record}
							router={this.props.router}
							deleteitem={item => this.showDelete(item)}
							// detailitem={item => this.showDetail(item)}
							actions_permissions={actions_permissions}
						/>
					)}
				/>
			);
		}
		return headers;
	}

	render() {
		const { pagination, hasHeader, headerComponent } = this.props;
		return (
			<div>
				<IF test={hasHeader}>
					<Card header title="Filtros e opções">
						<IF test={!headerComponent}>
							<button>Novo</button>
						</IF>
					</Card>
				</IF>
				<Card>
                    <div style={{display: 'flex', flex: 1, alignContent: 'flex-end', alignItems: 'flex-end', justifyContent: 'flex-end'}}>
					    <Button
							onClick={() => this.props.router.push(this.props.router.location.pathname+'/novo')}
                            text='Novo'
                            rounded
                            buttonType='primary'
                            textStyle={{color: '#555'}}
                            outline
                        />
                    </div>
                    <div>
                        <Table data={this.props.rows} rowKey={this.props.rowKey}>{this.renderColumns()}</Table>
                        <Pagination
                            getPage={page => this.props.getPagination(page)}
                            first_page={1}
                            current={pagination.current_page}
                            last_page={pagination.last_page}
                        />
                    </div>
				</Card>
				<ErrorModal
					isVisible={this.state.visible}
					btnCancel={{
						text: 'Cancelar',
						onClick: this.hideDelete
					}}
					btnOk={{
						text: 'Excluir',
						onClick: this.onDelete
					}}
				/>
			</div>
		);
	}
}

export default ResponsiveTable;
